export const OpenClosePrivacyPolicy = () =>({
    type: 'openClosePrivacyPolicy'
})